var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"double-arrow-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 8 14"}},[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"m1 4 3-3 3 3m0 6-3 3-3-3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }